<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/17Rj29P/tc-custom/9781429972413.jpg?1735615636542" alt="This image is the cover for the book Chicks Kick Butt"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Chicks Kick Butt
      </h1>
      <p class="bookDescription body article font2">
        <b>“A stellar introduction to the wide world of women in urban fantasy” featuring stories from Rachel Caine, L. A. Banks, Rachel Vincent, and ten others (<i>Library Journal</i>).</b><br/><br/>Chicks are awesome—and never more so than when they are kicking some serious vampire/werewolf/demon/monster butt.<br/><br/><i>Chicks Kick Butt</i> is an anthology that features one of the best things about the urban fantasy genre: strong, independent, and intelligent heroines who are quite capable of solving their own problems and slaying their own dragons (or demons, as the case may be).<br/><br/>Edited by Kerrie Hughes and Rachel Caine, <i>Chicks Kick Butt</i> features original stories from thirteen authors, eleven of whom are <i>New York Times</i> bestsellers:Rachel Caine (with a story from her bestselling Weather Wardens universe)L. A. BanksRachel VincentKaren ChanceLilith SaintcrowCheyenne McCraySusan KrinardJeanne SteinJenna BlackElizabeth VaughanCarole Nelson DouglasP. N. ElrodNancy Holder
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rachel Caine, Kerrie L. Hughes, L. A. Banks, Rachel Vincent
      </h2>
      
      <p class="authorDescription body article">Rachel Caine (1962&ndash;2020) was the <I>New York Times</I>&ndash;,<I> USA Today</I>&ndash;, and #1 <I>Wall Street Journal&ndash;</I>bestselling author of more than fifty books across multiple genres, from adult thriller to urban fantasy/science fiction, as well as works for young adults. With millions of copies sold, she was a frequent guest at conventions in the United States and around the world. Her popular book series include the Morganville Vampires novels, the Great Library series, and the #1-bestselling Stillhouse Lake books. Caine lost her fight with a rare and aggressive cancer, soft tissue sarcoma, in November of 2020.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?25ec8490